import { authApi } from "../interceptor/auth.interceptor";

class TikTokService {


    static async getAllAdv(queryParams) {
        return await authApi
            .get(`tiktok/adv-details?${queryParams}`)
            .then((response) => {
                return response?.data;
            });
    }

    static async changeAdvAccount(queryParams) {
        return await authApi
            .put(`tiktok/update-adv-account?${queryParams}`)
            .then((response) => {
                return response?.data;
            });
    }

}

export default TikTokService;
